<div *ngIf="appMetadataHandler.featureFlags.enableDynamicRendering">
    <nz-skeleton *ngIf="policyBasicDetailsMetadata.length == 0" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
        [nzLoading]="policyBasicDetailsMetadata.length == 0">
    </nz-skeleton>
    <div *ngIf="policyBasicDetailsMetadata.length>0">
        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]" [FORMTITLE]="'Policy Details'"
            FORMNAME="PolicyDetailsForm" [IO]="inputDataForEdit" [currentComponentName]="'PolicyDetailsComponent'"
            [(ngModel)]="policyBasicDetailsDataMap.PolicyDetailsComponent"
            (ngModelChange)="updateCoveragesComponentData($event)" [formMetaData]="policyBasicDetailsMetadata">
        </app-dynamic-form>
    </div>
</div>
<div *ngIf="!appMetadataHandler.featureFlags.enableDynamicRendering">
    <form [formGroup]="SubmissionDataForm">
        <div class="tab-grid grid-4x grid-gap-20 m-t-20">
            <nz-form-item *ngIf="proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('productType')">Product</nz-form-label>
                <nz-form-control id="productForm" [nzSpan]="24">
                    <!-- <input type="text" placeholder="{{'Product' | translate}}" nz-input formControlName="productType" />  [nzDisabled]="SubmissionDataForm.get('productType').value"-->
                    <nz-select nzShowSearch style="width: 100%" formControlName="productType" (ngModelChange)="productChanged()" (focus)="formDataChangeHandler('productType')" (ngModelChange)="formDataChangeHandler('productType')">
                        <nz-option class="nzOptions" *ngFor="let item of productDataLookup" [nzLabel]="item.lookupValue"
                            [nzValue]="item.lookupKey">
                        </nz-option>
                    </nz-select>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('productType').dirty || SubmissionDataForm.get('productType').touched) && SubmissionDataForm.get('productType').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('productType'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>

             <nz-form-item *ngIf="newBusinessAppSettings._allowedLOB=='HEALTH' && proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24">Plan Option
                </nz-form-label>
                <nz-form-control id="planOption" [nzSpan]="24">
                    <nz-select nzShowSearch style="width: 100%" formControlName="planType" (focus)="formDataChangeHandler('planType')" (ngModelChange)="formDataChangeHandler('planType')">
                        <nz-option *ngFor="let item of planList" [nzLabel]="item.lookupValue"
                            [nzValue]="item.lookupKey">
                        </nz-option>
                        <!-- <nz-option *ngFor="let item of (lookup$['productPlanType'] | async)" [nzLabel]="item.lookupValue | technicalTranslate"
                        [nzValue]="item.lookupKey">
                    </nz-option> -->
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="SubmissionDataForm.get('productType').value === 'SCBPSuperCreditLife1'">
                <nz-form-label [nzSpan]="24">Master Policy Number</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <input type="text" placeholder="{{'Master Policy Number' | translate}}" nz-input
                        formControlName="masterPolicyNo" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="SubmissionDataForm.get('productType').value === 'SCBPSuperCreditLife1'">
                <nz-form-label [nzSpan]="24"><span translate>Type of Cover</span></nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch id="coverType" formControlName="coverType" style="width: 100%" (focus)="formDataChangeHandler('coverType')" (ngModelChange)="formDataChangeHandler('coverType')">
                        <nz-option nzValue="LEVEL" nzLabel="Level Cover"></nz-option>
                        <nz-option nzValue="REDUCING" nzLabel="Reducing Cover"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="SubmissionDataForm.get('productType').value === 'SCBPSuperCreditLife1'">
                <nz-form-label [nzSpan]="24">
                    Term Type
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch id="termType" formControlName="termType" style="width: 100%" (focus)="formDataChangeHandler('termType')" (ngModelChange)="formDataChangeHandler('termType')">
                        <nz-option nzValue="FIXED" nzLabel="Fixed"></nz-option>
                        <nz-option nzValue="LOAN" nzLabel="Loan"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="newBusinessAppSettings._allowedLOB=='HEALTH' && proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24">Product Type
                </nz-form-label>
                <nz-form-control id="policyType" [nzSpan]="24">
                    <nz-select nzShowSearch style="width: 100%" formControlName="packageType" (focus)="formDataChangeHandler('packageType')" (ngModelChange)="formDataChangeHandler('packageType')">
                        <nz-option *ngFor="let item of packageList" [nzLabel]="item.lookupValue | technicalTranslate"
                            [nzValue]="item.lookupKey">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="newBusinessAppSettings._allowedLOB=='HEALTH' && proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24">Policy Type
                </nz-form-label>
                <div>
                    <span id="floaterid" *ngIf="SubmissionDataForm.get('packageType').value && SubmissionDataForm.get('packageType').value != 'INDIVIDUAL'">Individual</span>
                    <span *ngIf="SubmissionDataForm.get('packageType').value == 'INDIVIDUAL'">Individual</span>
                    <span *ngIf="!SubmissionDataForm.get('packageType').value">-</span>
                </div>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('purposeOfInsuranceType')">Purpose of Insurance
                </nz-form-label>
                <nz-form-control id="purposeOfInsurance" [nzSpan]="24">
                    <nz-select nzShowSearch style="width: 100%" formControlName="purposeOfInsuranceType" (focus)="formDataChangeHandler('purposeOfInsuranceType')" (ngModelChange)="formDataChangeHandler('purposeOfInsuranceType')">
                        <nz-option *ngFor="let item of (lookup$['purposeOfInsuranceCd'] | async)"
                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('purposeOfInsuranceType').dirty || SubmissionDataForm.get('purposeOfInsuranceType').touched) && SubmissionDataForm.get('purposeOfInsuranceType').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('purposeOfInsuranceType'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>
            <!-- <nz-form-item
                *ngIf="(SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1' && proposalType!=='MULTILIFE') || (SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1' && SubmissionDataForm.get('termType').value === 'FIXED' && proposalType!=='MULTILIFE')">
                <nz-form-label [nzSpan]=" 24" [nzRequired]="isRequired('sumInsured')">Sum Insured</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-input-group><input currencyMask [options]="appMetadataHandler.currencyOptions" type="text"
                            placeholder="{{'Sum Insured' | translate}}" nz-input formControlName="sumInsured" />
                    </nz-input-group>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('sumInsured').dirty || SubmissionDataForm.get('sumInsured').touched) && SubmissionDataForm.get('sumInsured').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('sumInsured'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>

                </nz-form-control>
            </nz-form-item> -->

            <nz-form-item
                *ngIf="SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1' && SubmissionDataForm.get('termType').value === 'LOAN'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('sumInsured')">Loan Amount</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-input-group><input currencyMask [options]="appMetadataHandler.currencyOptions" type="text"
                            placeholder="{{'Loan Amount' | translate}}" nz-input formControlName="sumInsured" />
                    </nz-input-group>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('sumInsured').dirty || SubmissionDataForm.get('sumInsured').touched) && SubmissionDataForm.get('sumInsured').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('sumInsured'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>

                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('currencyType')">Premium Currency</nz-form-label>
                <nz-form-control id="premiumCurrency" [nzSpan]="24">
                    <nz-select nzShowSearch style="width: 100%" formControlName="currencyType" (focus)="formDataChangeHandler('currencyType')" (ngModelChange)="formDataChangeHandler('currencyType')">
                        <nz-option *ngFor="let lookup of currencyLookup" [nzLabel]="lookup?.lookupValue"
                            [nzValue]="lookup?.lookupKey"></nz-option>
                    </nz-select>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('currencyType').dirty || SubmissionDataForm.get('currencyType').touched) && SubmissionDataForm.get('currencyType').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('currencyType'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngIf="newBusinessAppSettings._allowedLOB=='HEALTH' && proposalType!=='MULTILIFE'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('campaignCode')">Channel Name</nz-form-label>
                <nz-form-control id="campaignCode" [nzSpan]="24">
                    <nz-select nzShowSearch style="width: 100%" formControlName="campaignCode" (focus)="formDataChangeHandler('campaignCode')" (ngModelChange)="formDataChangeHandler('campaignCode')">
                        <nz-option *ngFor="let item of (lookup$['channelCd'] | async)"
                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('campaignCode').dirty || SubmissionDataForm.get('campaignCode').touched) && SubmissionDataForm.get('campaignCode').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('campaignCode'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('receivedDate')">Received Date</nz-form-label>
                <nz-form-control id="
                receivedDateForm" [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                    <nz-date-picker id="recievedDatePicker"
                        nzFormat="dd MMM yyyy"
                        [nzDisabledDate]="disabledDateFuture"
                        formControlName="receivedDate" class="w-100-pc" (focus)="formDataChangeHandler('receivedDate')" (ngModelChange)="formDataChangeHandler('receivedDate')"></nz-date-picker>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('receivedDate').dirty || SubmissionDataForm.get('receivedDate').touched) && SubmissionDataForm.get('receivedDate').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('receivedDate'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('signedDate')">Signed Date</nz-form-label>
                <nz-form-control id="signedDate" [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                    <nz-date-picker id="signedDateCheck"
                        nzFormat="dd MMM yyyy"
                        [nzDisabledDate]="disabledDateFuture"
                        formControlName="signedDate" class="w-100-pc" (focus)="formDataChangeHandler('signedDate')" (ngModelChange)="formDataChangeHandler('signedDate')"></nz-date-picker>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('signedDate').dirty || SubmissionDataForm.get('signedDate').touched) && SubmissionDataForm.get('signedDate').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('signedDate'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('inceptionDate')">Policy Start Date
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-date-picker nzFormat="dd MMM yyyy" formControlName="inceptionDate" class="w-100-pc" (focus)="formDataChangeHandler('inceptionDate')" (ngModelChange)="formDataChangeHandler('inceptionDate')"></nz-date-picker>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('inceptionDate').dirty || SubmissionDataForm.get('inceptionDate').touched) && SubmissionDataForm.get('inceptionDate').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('inceptionDate'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>

            <div
                *ngIf="SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1' && policyTermLookup && policyTermLookup.length==0">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                        Term
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input type="text" placeholder="{{'Term' | translate}}" nz-input formControlName="term" (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')"/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div
                *ngIf="SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1' && policyTermLookup && policyTermLookup.length>0">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                        Term
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-select nzShowSearch style="width: 100%" formControlName="term" (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')">
                            <nz-option *ngFor="let item of policyTermLookup" [nzLabel]="item.lookupValue"
                                [nzValue]="item.lookupKey">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <nz-form-item *ngIf="SubmissionDataForm.get('productType').value == 'SCBPSuperCreditLife1'">
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('expiryDate')">Policy End Date
                </nz-form-label>
                <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                    <nz-date-picker nzFormat="dd MMM yyyy" formControlName="expiryDate" disabled  class="w-100-pc" (focus)="formDataChangeHandler('expiryDate')" (ngModelChange)="formDataChangeHandler('expiryDate')">
                    </nz-date-picker>
                    <nz-form-explain
                        *ngIf="(SubmissionDataForm.get('expiryDate').dirty || SubmissionDataForm.get('expiryDate').touched) && SubmissionDataForm.get('expiryDate').errors">
                        <p style="color:red"
                            *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('expiryDate'), SUBMISSIONDATAFORMNAME)">
                            {{error.errorMessage}}</p>
                    </nz-form-explain>
                </nz-form-control>
            </nz-form-item>
            <!-- -->
            <ng-container *ngIf="appMetadataHandler['allowedLOB'] == 'LIFE'">
                <ng-container
                    *ngIf="appMetadataHandler['allowedLOB'] != 'LIFE' && SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">
                    <nz-form-item *ngIf="SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">
                        <nz-radio-group id="radioGroup" [(ngModel)]="displayField" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="clearData()" [nzButtonStyle]="'solid'" [nzSize]="'small'">
                            <label id="radioTerm" nz-radio-button nzValue="TERM">
                                <i nz-icon nzType="hourglass" nzTheme="outline"></i> Term
                            </label>
                            <label id="radioExpiry" nz-radio-button nzValue="EXPIRYDATE">
                                <i nz-icon nzType="calendar" nzTheme="outline"></i> Expiry
                            </label>
                        </nz-radio-group>
                    </nz-form-item>
                </ng-container>

                <ng-container *ngIf="SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">

                    <nz-form-item>
                        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('inceptionDate')">
                            Policy Start Date
                        </nz-form-label>
                        <nz-form-control id="policyStartDate" [nzSpan]="24">
                            <!-- [nzDisabledDate]="disabledDatePast" ** removed disable logic as Policy start date can be past date -->
                            <nz-date-picker nzFormat="dd MMM yyyy" formControlName="inceptionDate" class="w-100-pc"
                                (focus)="formDataChangeHandler('inceptionDate')"
                                (ngModelChange)="formDataChangeHandler('inceptionDate')"></nz-date-picker>
                            <nz-form-explain
                                *ngIf="(SubmissionDataForm.get('inceptionDate').dirty || SubmissionDataForm.get('inceptionDate').touched) && SubmissionDataForm.get('inceptionDate').errors">
                                <p style="color:red"
                                    *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('inceptionDate'), SUBMISSIONDATAFORMNAME)">
                                    {{error.errorMessage}}</p>
                            </nz-form-explain>
                        </nz-form-control>
                    </nz-form-item>

                    <div *ngIf="policyTermLookup && policyTermLookup.length==0">
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                                Term
                            </nz-form-label>
                            <nz-form-control id="formTerm" [nzSpan]="24">
                                <input type="number" placeholder="{{'Term' | translate}}" min="0" nz-input formControlName="term"
                                    (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                    <div *ngIf="policyTermLookup && policyTermLookup.length>0">
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                                Term
                            </nz-form-label>
                            <nz-form-control [nzSpan]="24">
                                <nz-select nzShowSearch style="width: 100%" formControlName="term"
                                    (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')">
                                    <nz-option *ngFor="let item of policyTermLookup" [nzLabel]="item.lookupValue"
                                        [nzValue]="item.lookupKey">
                                    </nz-option>
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                    <nz-form-item *ngIf="appMetadataHandler['allowedLOB'] != 'LIFE'">
                        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('expiryDate')">Policy Expiry Date
                        </nz-form-label>
                        <nz-form-control id="policyExpiryDate" [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                            <nz-date-picker nzFormat="dd MMM yyyy" formControlName="expiryDate" [nzDisabled]="displayField=='TERM'"
                                class="w-100-pc" (focus)="formDataChangeHandler('expiryDate')"
                                (ngModelChange)="formDataChangeHandler('expiryDate')"></nz-date-picker>
                            <nz-form-explain
                                *ngIf="(SubmissionDataForm.get('expiryDate').dirty || SubmissionDataForm.get('expiryDate').touched) && SubmissionDataForm.get('expiryDate').errors">
                                <p style="color:red"
                                    *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('expiryDate'), SUBMISSIONDATAFORMNAME)">
                                    {{error.errorMessage}}</p>
                            </nz-form-explain>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- <nz-form-item *ngIf="appMetadataHandler['LOB'] == 'LIFE'">
                        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('anniversaryDt')">
                            Policy Anniversary Date
                        </nz-form-label>
                        <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                            <nz-date-picker nzMode="month" nzFormat="dd MMM" formControlName="anniversaryDt" nzDisabled
                                class="w-100-pc" (focus)="formDataChangeHandler('anniversaryDt')"
                                (ngModelChange)="formDataChangeHandler('anniversaryDt')"></nz-date-picker>
                            <nz-form-explain
                                *ngIf="(SubmissionDataForm.get('anniversaryDt').dirty || SubmissionDataForm.get('anniversaryDt').touched) && SubmissionDataForm.get('anniversaryDt').errors">
                                <p style="color:red"
                                    *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('anniversaryDt'), SUBMISSIONDATAFORMNAME)">
                                    {{error.errorMessage}}</p>
                            </nz-form-explain>
                        </nz-form-control>
                    </nz-form-item> -->

                </ng-container>
            </ng-container>


            <!-- <nz-form-item>
            <h3>Enter by</h3>
            <nz-radio-group formControlName="enterByPanel" [nzButtonStyle]="'solid'" [nzSize]="'small'">
                <label nz-radio-button nzValue="EXPIRYDATE">
                    <i nz-icon nzType="calendar" nzTheme="outline"></i> Expiry Date
                </label>
                <label nz-radio-button nzValue="TERM">
                    <i nz-icon nzType="hourglass" nzTheme="outline"></i> Term
                </label>
            </nz-radio-group>
        </nz-form-item> -->

        </div>

        <ng-container *ngIf="appMetadataHandler['allowedLOB'] != 'LIFE'">
            <div class="tab-grid" *ngIf="appMetadataHandler['allowedLOB'] != 'LIFE' && SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">
                <nz-form-item *ngIf="SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">
                    <nz-radio-group id="radioGroup" [(ngModel)]="displayField" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="clearData()" [nzButtonStyle]="'solid'" [nzSize]="'small'">
                        <label id="radioTerm" nz-radio-button nzValue="TERM">
                            <i nz-icon nzType="hourglass" nzTheme="outline"></i> Term
                        </label>
                        <label id="radioExpiry" nz-radio-button nzValue="EXPIRYDATE">
                            <i nz-icon nzType="calendar" nzTheme="outline"></i> Expiry
                        </label>
                    </nz-radio-group>
                </nz-form-item>
            </div>
    
            <div class="tab-grid grid-4x grid-gap-20 m-t-20" *ngIf="SubmissionDataForm.get('productType').value != 'SCBPSuperCreditLife1'">
    
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('inceptionDate')">
                        Policy Start Date
                    </nz-form-label>
                    <nz-form-control id="policyStartDate" [nzSpan]="24">
                        <!-- [nzDisabledDate]="disabledDatePast" ** removed disable logic as Policy start date can be past date -->
                        <nz-date-picker 
                            nzFormat="dd MMM yyyy" 
                            formControlName="inceptionDate" class="w-100-pc" (focus)="formDataChangeHandler('inceptionDate')" (ngModelChange)="formDataChangeHandler('inceptionDate')"></nz-date-picker>
                        <nz-form-explain
                            *ngIf="(SubmissionDataForm.get('inceptionDate').dirty || SubmissionDataForm.get('inceptionDate').touched) && SubmissionDataForm.get('inceptionDate').errors">
                            <p style="color:red"
                                *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('inceptionDate'), SUBMISSIONDATAFORMNAME)">
                                {{error.errorMessage}}</p>
                        </nz-form-explain>
                    </nz-form-control>
                </nz-form-item>
    
                <div *ngIf="policyTermLookup && policyTermLookup.length==0">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                            Term
                        </nz-form-label>
                        <nz-form-control id="formTerm" [nzSpan]="24">
                            <input type="number" placeholder="{{'Term' | translate}}" min = "0" nz-input formControlName="term" (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')"/>
                        </nz-form-control>   
                    </nz-form-item>
                </div>
    
                <div *ngIf="policyTermLookup && policyTermLookup.length>0">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('term')">
                            Term
                        </nz-form-label>
                        <nz-form-control [nzSpan]="24">
                            <nz-select nzShowSearch style="width: 100%" formControlName="term" (focus)="formDataChangeHandler('term')" (ngModelChange)="formDataChangeHandler('term')">
                                <nz-option *ngFor="let item of policyTermLookup" [nzLabel]="item.lookupValue"
                                    [nzValue]="item.lookupKey">
                                </nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>
    
                <nz-form-item *ngIf="appMetadataHandler['allowedLOB'] != 'LIFE'">
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('expiryDate')">Policy Expiry Date
                    </nz-form-label>
                    <nz-form-control id="policyExpiryDate" [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                        <nz-date-picker nzFormat="dd MMM yyyy" formControlName="expiryDate" [nzDisabled]="displayField=='TERM'" class="w-100-pc" (focus)="formDataChangeHandler('expiryDate')" (ngModelChange)="formDataChangeHandler('expiryDate')"></nz-date-picker>
                        <nz-form-explain
                            *ngIf="(SubmissionDataForm.get('expiryDate').dirty || SubmissionDataForm.get('expiryDate').touched) && SubmissionDataForm.get('expiryDate').errors">
                            <p style="color:red"
                                *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('expiryDate'), SUBMISSIONDATAFORMNAME)">
                                {{error.errorMessage}}</p>
                        </nz-form-explain>
                    </nz-form-control>
                </nz-form-item>
    
                <!-- <nz-form-item *ngIf="appMetadataHandler['LOB'] == 'LIFE'">
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('anniversaryDt')">
                        Policy Anniversary Date
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                        <nz-date-picker nzMode="month"  nzFormat="dd MMM" formControlName="anniversaryDt" nzDisabled class="w-100-pc" (focus)="formDataChangeHandler('anniversaryDt')" (ngModelChange)="formDataChangeHandler('anniversaryDt')"></nz-date-picker>
                        <nz-form-explain
                            *ngIf="(SubmissionDataForm.get('anniversaryDt').dirty || SubmissionDataForm.get('anniversaryDt').touched) && SubmissionDataForm.get('anniversaryDt').errors">
                            <p style="color:red"
                                *ngFor="let error of validationUtilService.getUIErrorList(SubmissionDataForm.get('anniversaryDt'), SUBMISSIONDATAFORMNAME)">
                                {{error.errorMessage}}</p>
                        </nz-form-explain>
                    </nz-form-control>
                </nz-form-item> -->
    
            </div>
        </ng-container>
    </form>
</div>